<template>
    <div class="d-block">
        <page-banner v-bind:data="bannerData" v-if="bannerData"/>
        <div class="d-block" style="padding: 0 64px;">
            <Row :gutter="64" v-for="(item, index) in experimentList" :key="index" style="margin-bottom: 64px;">
                <Col span="12">
                    <div class="d-block">
                        <h1 class="experiment-title">{{ item.title }}</h1>
                        <br/>
                        <p class="size-24 line-h-36" style="text-indent: 2em;">{{ item.introduction }}</p>
                        <br/>
                        <br/>
                        <p v-if="item.content">
                            <a class="btn-view-more" @click="onExperiment(item, index)">
                                <span class="d-flex justify-start">
                                    <Icon type="ios-arrow-dropright" size="20"/>
                                    <u class="pl-xs">{{ language === 'zh-cn' ? '详情' : 'View More' }}</u>
                                </span>
                            </a>
                        </p>
                    </div>
                </Col>
                <Col span="12">
                    <div class="experiment-box">
                        <div class="header">
                            <i class="red">&nbsp;</i>
                            <i class="yellow">&nbsp;</i>
                            <i class="green">&nbsp;</i>
                        </div>
                        <div class="d-block p-sm">
                            <swiper :options="swiperOption" v-if="item.mediaType === 'IMAGE'" :style="{width: ($common.winContent().width / 2 - 186) + 'px'}">
                                <swiper-slide class="d-flex justify-center" v-for="(img, index) in item.url" :key="index">
                                    <div class="d-flex justify-center height-all" style="height: 480px;">
                                        <img :src="img" style="max-width: 100%; max-height: 100%;"/>
                                    </div>
                                </swiper-slide>
                            </swiper>
                            <video-player ref="VideoPlayer" v-bind:data="item.url" v-if="item.mediaType === 'VIDEO'" style="height: 420px;"/>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>

        <details-modal v-if="isDetailsModal" v-bind:lang="language" v-bind:data="detailsModalData" @actions="detailsModalActions"/>
    </div>
</template>

<script type="text/javascript">
    import PageBanner from "../../components/PageBanner";
    import VideoPlayer from "../../components/VideoPlayer";
    import DetailsModal from "../../components/DetailsModal";

    export default {
        components: {
            PageBanner, VideoPlayer, DetailsModal
        },
        data () {
            return {
                language: 'zh-cn',
                bannerData: null,
                experimentList: [],
                swiperOption: {
                    notNextTick: true,
                    loop: false, // 循环
                    initialSlide: 0, // 初始化索引
                    autoplay: true, // 自动
                    speed: 500, // 滑动速度
                    direction: "horizontal", // 方向
                },
                isDetailsModal: false,
                detailsModalData: null,
                total: 0,
                current: 1,
                pageSize: 10,
            }
        },
        created() {
            console.log('当前语言----->' + this.$store.state.language);
            this.language = this.$store.state.language;
        },
        mounted() {
            this.__getBanner();
            this.__getExperimentList(1);
        },
        methods: {
            __getBanner(){
                this.$api.getHttp('banner?bannerType=EXPERIMENT', {
                    language: this.language,
                }).then((res) => {
                    // console.log('<---------- res ---------->');
                    // console.log(res);
                    if (res.status === 200){
                        this.bannerData = res.data.data;
                        // console.log(this.bannerData);
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },
            __getExperimentList(page){
                this.$api.getHttp('experiment?pageIndex=' + page + "&pageSize=" + this.pageSize, {
                    language: this.language,
                }).then((res) => {
                    // console.log('<---------- res ---------->');
                    // console.log(res);
                    if (res.status === 200){
                        this.total = res.data.data.total;
                        this.experimentList = res.data.data.data;
                        console.log('<---------- res ---------->');
                        console.log(this.experimentList);
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },
            onExperiment(data, i){
                console.log(data, i);
                this.isDetailsModal = true;
                this.detailsModalData = data;
            },
            detailsModalActions(data){
                console.log(data);
                this.isDetailsModal = data;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/experiment/list.vue